import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: {
            id: 0,
            name: 'guest',
            email: 'gu@e.st',
            group: 1
        },
        website: {
            id: 0,
            name: '请选择站点',
            site_character: 1,
            service_area_name: '',
            service_area_id: 0,
            serviceValue: []
        },
        userAppList: {},
        maskShown: { isShow: false, zIndex: 9999 },
        appUrls: {
            app_url: '',
            mc_url: '',
            open_url: '',
            uc_url: '',
            wx_appid: '',
            wx_plat_appid: '',
            wx_push_appid: ''
        },
        sites: [],
        serviceList: [],
        minHeight: 768,
        minWidth: 1200,
        contentWidth: 1200,
        targetEmail: '',
        appConfig: ''
    },
    mutations: {
        user(state, user) {
            state.user = user;
        },
        website(state, site) {
            state.website = { ...site };
        },
        mask(state, shown) {
            state.maskShown = shown;
        },
        appUrls(state, urls) {
            state.appUrls = { ...urls };
        },
        userAppList(state, result) {
            state.userAppList = result;
        },
        sites(state, data) {
            state.sites = data;
        },
        updateUser(state, data) {
            state.user[data.key] = data.val;
        },
        serviceList(state, data) {
            state.serviceList = data;
        },
        minHeight(state, val) {
            state.minHeight = val;
        },
        minWidth(state, val) {
            state.minWidth = val;
        },
        contentWidth(state, val) {
            state.contentWidth = val;
        },
        targetEmail(state, val) {
            state.targetEmail = val;
        },
        appConfig(state, val) {
            state.appConfig = val;
        }
    },
    actions: {}
});
